import User from '@/entities/User';
import api from '@/services/Api';

export default {
  update(id, { firstname, lastname, email }) {
    const data = {
      firstname,
      lastname,
      email,
    };

    return api().put('/user/' + id, data).then(resp => new User(resp));
  },

  changeLevel(id, { level, visibleBrandIds }) {
    const data = {
      level,
    };

    if (typeof visibleBrandIds !== 'undefined') {
      data['visible_brand_ids'] = visibleBrandIds;
    }

    return api().put('/user/' + id + '/change-level', data).then(resp => new User(resp));
  },

  changeLanguage(id, language) {
    const data = { language };

    return api().put('/user/' + id + '/language', data);
  },

  delete(id) {
    return api().delete('/user/' + id);
  },
};
